import { Typography } from '@/components';
import { useTranslation } from 'react-i18next';

export function OpportunitiesContentHeader() {
  const { t } = useTranslation(['opportunities']);

  return (
    <>
      <Typography as="h1" size="heading-2" weight="semibold" className="mb-4 sm:mb-3">
        {t('Opportunities')}
      </Typography>
    </>
  );
}
